import { render, staticRenderFns } from "./UtilAvatar.vue?vue&type=template&id=1099b0bc&scoped=true"
import script from "./UtilAvatar.vue?vue&type=script&lang=js"
export * from "./UtilAvatar.vue?vue&type=script&lang=js"
import style0 from "./UtilAvatar.vue?vue&type=style&index=0&id=1099b0bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1099b0bc",
  null
  
)

export default component.exports